export default __webpack_public_path__ + "static/newsback-917f7b97e1ebf935d6b564b9f2d166cb.png";